import '../../node_modules/bootstrap/js/dist/modal';
import '../../node_modules/bootstrap/js/dist/collapse';
import '../../node_modules/bootstrap/js/src/dropdown';

import {maybeUpdateTimezones, maybeInitMapLinks, pushAnalyticsData} from "./utils";

( function( $ ) {
	'use strict';

	$(document).ready(function() {

		maybeUpdateTimezones();

		maybeInitMapLinks();

		$( '.js-disable-click' ).on( 'click', ( e ) => {
			e.preventDefault();
			return false;
		} );

		/**
		 * Check if a user has scrolled to a products list to track on GA4.
		 */

		const courseLists = document.querySelectorAll( '[data-module="course-list"]' );

		if ( courseLists.length > 0 ) {

			courseLists.forEach( function( courseList ) {
				courseList.listViewed = false;
				let productCodes = [];

				// Get all the products in the list.
				const cards = courseList.querySelectorAll( '.card' );

				cards.forEach( function( card ) {
					const addToCartContainer = card.querySelector( '.add-to-cart-container' );
					const productCode = addToCartContainer ? addToCartContainer.getAttribute( 'data-alt-product-code' ) ?? addToCartContainer.getAttribute( 'data-product-code' ): null;
					if ( productCode ) {
						productCodes.push( productCode );
					}
				});

				courseList.productCodes = productCodes;
			});

			window.addEventListener( 'scroll', checkIfProductsListInViewport );
			checkIfProductsListInViewport();

			const packagesTabs = document.querySelectorAll( '.wp-block-colibri-tabs__tab' );

			packagesTabs.forEach( function ( packagesTab ) {
				packagesTab.addEventListener( 'click', function() {
					checkIfProductsListInViewport();
				});
			});

			function checkIfProductsListInViewport() {
				const viewportHeight = window.innerHeight;

				courseLists.forEach( function ( courseList ) {
					if ( courseList.offsetParent ) {
						const courseListPosition = courseList.getBoundingClientRect().top;

						const scrollThreshold = courseListPosition - ( viewportHeight / 3 );

						if (scrollThreshold <= 0 && scrollThreshold > ( -courseList.offsetHeight + ( viewportHeight / 3 ) ) ) {
							if ( courseList.listViewed === false ) {
								pushAnalyticsData('list', 'view_item_list', courseList.productCodes);
								courseList.listViewed = true;
							}
						} else {
							courseList.listViewed = false;
						}
					}
				});
			}
		}

		/**
		 * Check if a user is viewing a Product Details page to track on GA4.
		 */

		const body = document.body;
		if ( body.classList.contains( 'single-product' ) ) {
			const productCodeElement = document.querySelector( '[data-product-code]' );
			const productCode = productCodeElement.getAttribute( 'data-product-code' );
			pushAnalyticsData( productCode, 'view_item' );
		}

		/**
		 * Check if a user opened a View Product Details modal to track on GA4.
		 */

		const viewDetailsButtons = document.querySelectorAll( '.details-page-link[rel="modal"]' );

		viewDetailsButtons.forEach( function ( viewDetailsButton ) {
			viewDetailsButton.addEventListener( 'click', onViewDetailsButtonClick );
		});

		function onViewDetailsButtonClick( event ) {
			const productCode = event.target.getAttribute( 'data-product-code' );
			pushAnalyticsData( productCode, 'view_item' );
		}
	});

} )( jQuery );
